module.exports = __webpack_public_path__ + "icons/shield-7995cd9f3c7764eb2a61f1a81fcd9f23.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/shield.svg
// module id = ycZO
// module chunks = 20